export const LoginPageTitle = `Welcome to Livingston Research freelancer platform!\n\rYour application process won’t take a while and begins right away.\n\rGood luck!`;
export const LoginPageSubTitle = 'Use password from your email to login to your application';



// WEBPACK FOOTER //
// ./src/custom/livres/LoginPageText.js